import { TabStyles } from '@tableau/widgets';
import { cssClass } from '../../../style';

export namespace AddNewPermissionStyles {
  export const addNewPermissionCssPrefix = 'AddNewPermission';
  export const buttonContainer = 'button-container';
  export const ButtonTopMargin = 12;

  export const ButtonContainer = cssClass(addNewPermissionCssPrefix, buttonContainer, {
    marginTop: `${ButtonTopMargin}px`,
  });

  export const ButtonContent = cssClass(addNewPermissionCssPrefix, 'button-content', {
    alignItems: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
  });
}
